/**
 * Нормализация ответа GET finansist/catalog/projects.
 */
export const normalizeFinansistCatalogProjects = (data) => {
  const raw = Array.isArray(data)
    ? data
    : data?.listProject ??
      data?.listProjects ??
      data?.projects ??
      data?.items ??
      [];

  return raw
    .map((item) => {
      const id = Number(
        item.projectId ?? item.project_id ?? item.id ?? item.finansist_project_id,
      );
      const name =
        item.name ??
        item.projectName ??
        item.project_name ??
        item.finansist_project_name ??
        (Number.isFinite(id) ? String(id) : "");
      return { value: id, label: name, raw: item };
    })
    .filter((o) => Number.isFinite(o.value) && o.value > 0 && o.label);
};

export const emptyFinansistMappingFormState = () => ({
  finansistProject: null,
});

/** Маппинг из ответа GET projects (имя поля на бэкенде — с суффиксом _mappings). */
export const getProjectFinansistMapping = (project) => {
  if (!project || typeof project !== "object") return null;
  return (
    project.finansist_payroll_project_mappings ??
    project.finansist_payroll_mapping ??
    null
  );
};

export const mappingToFormState = (mapping) => {
  if (!mapping || typeof mapping !== "object") {
    return emptyFinansistMappingFormState();
  }

  const finansistId = Number(mapping.finansist_project_id);
  if (!Number.isFinite(finansistId) || finansistId <= 0) {
    return emptyFinansistMappingFormState();
  }

  return {
    finansistProject: {
      value: finansistId,
      label:
        mapping.finansist_project_name || String(finansistId),
    },
  };
};

/**
 * Собрать тело finansist_payroll_mapping для create/update проекта.
 */
export const buildFinansistPayrollMappingPayload = ({
  portalProjectId,
  portalProjectName,
  finansistProject,
}) => {
  if (!finansistProject?.value) {
    return null;
  }

  return {
    portal_project_id: Number(portalProjectId) || 0,
    portal_project_name: portalProjectName || "",
    finansist_project_name: finansistProject.label,
    finansist_project_id: Number(finansistProject.value),
  };
};
